import { render, staticRenderFns } from "./VirtualNubanAccounts.vue?vue&type=template&id=95119292"
var script = {}
import style0 from "./VirtualNubanAccounts.vue?vue&type=style&index=0&id=95119292&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports